// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__63C-X","wrapper":"Form_wrapper__1YtfU","input":"Form_input__1fq3g","button":"Form_button__3RwHk"};